import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Switch, Row, Col } from "antd";

import EntityInfo from "../../types/EntityInfo";
import { useTexts } from "../../hooks/useTexts";

type Props = {
    open: boolean,
    onClose: () => void,
    onSave: () => void,

    roles: EntityInfo[],
    cities: EntityInfo[],
    products: EntityInfo[],

    selectedUser: any,
    setSelectedUser: (u: any) => void
}

const UserModal = ({
    open,
    onClose,
    onSave,
    roles,
    cities,
    products,
    selectedUser,
    setSelectedUser
}: Props): JSX.Element => {
    const { t } = useTexts();
    const [form] = Form.useForm();

    useEffect(() => {
        if (open && selectedUser) {
            form.setFieldsValue({
                fullname: `${selectedUser.firstname} ${selectedUser.lastname}`,
                username: selectedUser.username,
                roleIds: selectedUser.roleIds,
                cityIds: selectedUser.cityIds,
                productIds: selectedUser.productIds,
                active: selectedUser.active
            });
        }
    }, [open, selectedUser, form]);

    const handleValuesChange = (changedValues: any, allValues: any) => {
        setSelectedUser({ ...selectedUser, ...changedValues });
    };

    return (
        <Modal
            title={t('user', 'edit')}
            open={open}
            onCancel={onClose}
            onOk={() => {
                form.validateFields().then(() => {
                    onSave();
                });
            }}
            okText={t('common', 'save')}
            cancelText={t('common', 'close')}
            width={800}
        >
            <Form
                form={form}
                layout="vertical"
                onValuesChange={handleValuesChange}
                style={{ marginTop: '24px' }}
            >
                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item label={t('user', 'fullName')} name="fullname">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label={t('user', 'username')} name="username">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item label={t('user', 'selectRole')} name="roleIds">
                            <Select
                                mode="multiple"
                                placeholder={t('user', 'selectRole')}
                                options={roles?.map(r => ({ label: t('role', r.name) || r.name, value: r.id }))}
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label={t('user', 'selectCity')} name="cityIds">
                            <Select
                                mode="multiple"
                                placeholder={t('user', 'selectCity')}
                                options={cities?.map(c => ({ label: c.name, value: c.id }))}
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16} align="middle">
                    <Col xs={24} md={12}>
                        <Form.Item label={t('user', 'selectProduct')} name="productIds">
                            <Select
                                mode="multiple"
                                placeholder={t('user', 'selectProduct')}
                                options={products?.map(p => ({ label: p.name, value: p.id }))}
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <Form.Item label={t('user', 'active')} name="active" valuePropName="checked" style={{ marginBottom: 0 }}>
                            <Switch />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default UserModal;
